// src/views/Seguridad/Usuario/VerUsuario.jsx
import React, { useEffect, useState } from "react";
import apiRoutes from "../../../api/apiRoutes";
import { apiFetchJson } from "../../../utils/http";

export default function VerUsuario({ id, onClose = () => {} }) {
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");
  const [u, setU] = useState(null);

  useEffect(() => {
    if (!id) return;
    let abort = new AbortController();
    async function load() {
      setLoading(true);
      setErr("");
      try {
        const url = apiRoutes.usuarios.detail(id);
        const data = await apiFetchJson(url, { signal: abort.signal });
        setU(data);
      } catch (e) {
        if (e?.name !== "AbortError") {
          setErr(e?.message || "Error al cargar el usuario.");
        }
      } finally {
        setLoading(false);
      }
    }
    load();
    return () => abort.abort();
  }, [id]);

  const rows = [
    ["Código", u?.codigo ?? ""],
    ["Estado", u?.estadoNombre ?? ""],
    ["Cliente", u?.clienteNombre ?? ""],
    ["Tarjeta", u?.tarjetaNumero ?? ""],
    ["Nombre", u?.nombreUsuario ?? ""],
    ["Cargo", u?.cargoUsuario ?? ""],
    ["Rol", u?.rol ?? ""],
  ];

  return (
    <div className="modal-backdrop">
      <div className="modal-panel-lg">
        {/* Encabezado */}
        <div className="modal-header">
          <h2 className="section-title">Datos de Usuario</h2>
        </div>

        {/* Contenido */}
        <div className="modal-body">
          {loading && <div className="py-6 text-center text-gray-600">Cargando…</div>}
          {!loading && err && <div className="py-6 text-center text-red-600">{err}</div>}
          {!loading && !err && u && (
            <>
              <div className="form-grid mb-4">
                {rows.map(([label, value]) => (
                  <Fila key={label} label={label} value={value} />
                ))}
              </div>

              {/* Bloque de permisos */}
              {Array.isArray(u.permisos) && u.permisos.length > 0 && (
                <div className="mt-6">
                  <h3 className="font-semibold text-gray-800 mb-2">Permisos asignados</h3>
                  <div className="border rounded p-3 bg-gray-50 max-h-48 overflow-auto">
                    <ul className="list-disc list-inside text-sm text-gray-700 space-y-1">
                      {u.permisos.map((perm, i) => (
                        <li key={i}>{perm}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}
            </>
          )}
        </div>

        {/* Footer */}
        <div className="modal-footer">
          <div className="flex justify-end">
            <button className="btn-fil" onClick={onClose}>
              Nueva consulta
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

function Fila({ label, value }) {
  return (
    <div className="form-row">
      <div className="form-label">{label}:</div>
      <div className="value">{value || ""}</div>
    </div>
  );
}
